export default {
    common: {
        goBack: 'Ga terug',
        home: 'Home',
        remove: 'Verwijder',
        test: 'proef',
    },
    dropzone: {
        addMore: 'Voeg meer bestanden toe',
        canOnlyUploadImages:
            'Het bestand dat je probeert te uploaden is niet toegestaan. Je kan hier alleen afbeeldingen uploaden.',
        canOnlyUploadPDF:
            'Het bestand dat je probeert te uploaden is niet toegestaan. Je kan hier alleen PDF bestanden uploaden.',
        dragAndDropUploader: 'Drag and Drop uploader',
        dragFiles: 'Klik of sleep je bestanden in dit vak',
        dropFiles: 'Drop bestand',
        fileTooBig: 'Het bestand is te groot',
        invalidFileType: 'Ongeldig bestandstype',
        maxFilesExceeded: 'Je kan niet meer bestanden toevoegen',
        removeFile: 'Verwijder bestand',
        serverNotConfigured: 'Server niet geconfigureerd',
        toUpload: 'naar upload',
        uploadError: 'Bestanden toevoegen mislukt',
    },
    errorCodes: {
        TOO_MANY_ATTACHMENTS: 'Je hebt te veel bestanden toegevoegd. Blijf binnen de limiet van {0} bestanden',
    },
    errorPages: {
        generalBody:
            'We hebben allemaal wel eens onze ups en downs. Ons technische team gaat het zo snel mogelijk oplossen.',
        generalNeedHelp: 'Hulp nodig? Bel',
        generalOpeningHours: 'Maandag - vrijdag van 8:30 - 17:00 uur',
        generalSendEmail: 'Of stuur een e-mail naar info@ksyos.nl',
        generalTitle: 'Er is iets verkeerd gegaan.',
        rumSessionId: 'Sessie ID',
    },
    errorResponses: {
        authorization: 'Je hebt geen toegang (meer) tot deze pagina of dit bestand.',
        controller: 'Er is een fout opgetreden. (Technische status: {0})',
        internal: 'Er is een interne server fout opgetreden.',
        joiValidation: 'Er zit een fout in de aanvraag. (Technische details: type "{0}", path "{1}")',
        noSession:
            'Je sessie is afgelopen of je was niet ingelogd. Navigeer alstublieft naar <a href="/home?view=login">login</a>.',
        notAllowed: 'Je hebt geen toegang (meer) tot deze pagina of dit bestand.',
        notFound: 'Deze pagina (of dit bestand) bestaat niet.',
        samlError:
            'Er is een fout opgetreden in de communicatie met DigiD. Probeert u het later nogmaals. Indien deze fout blijft aanhouden, kijk dan op de website <a href="https://www.digid.nl">https://www.digid.nl</a> voor de laatste informatie of navigeer alstublieft naar <a href="/login">login</a>.',
        unexpected: 'Er is een onverwachte interne fout opgetreden.',
        validation: 'Er zit een fout in de aanvraag. (Technische code: {0})',
        zxyTokenMissing: 'Het beveilingsteken mist.',
        zxyTokenNoMatch: 'Het beveilingsteken is incorrect.',
    },
    timeout: {
        message: 'Om je gegevens te beschermen ben je na 15 minuten inactiviteit uitgelogd.',
        title: 'De sessie is verlopen',
    },
    validation: {
        any_allowOnly: 'Vul een geldige waarde in',
        any_empty: 'Mag niet leeg zijn',
        any_emptySupport: 'Je hebt niets ingevuld',
        any_invalid: 'De ingevulde waarde is incorrect',
        any_required: 'Mag niet leeg zijn',
        any_selected: 'Kies één van de opties',
        boolean_base: 'Mag niet leeg zijn',
        date_future: 'Datum mag niet in de toekomst liggen',
        differentBsn: 'Dit is niet het BSN van de patiënt',
        EXTERNALID_EXISTS: 'Dit serienummer bestaal al voor dit device type',
        fev1: 'Moet een getal zijn tussen 0 en 9 met twee decimalen',
        general: 'Er is iets mis gegaan, probeer het alstublieft nogmaals.',
        graderRequired: 'Grader is verplicht',
        greater: '"{0}" moet groter zijn dan "{1}"',
        IDENTIFIER_DECLARATION_EXISTS: 'Dit nummer is reeds in gebruik',
        IDENTIFIER_REGISTRATION_EXISTS: 'Dit nummer is reeds in gebruik',
        identifierDeclarationOrReferenceRequired:
            'Voor dit beroep is de AGB code of het gebruik van de AGB code van een collega verplicht',
        image_required: 'Je moet hier nog een plaatje selecteren',
        invalidPhoneNumber: 'Het telefoonnummer lijkt niet te kloppen. Check o.a. of er minstens 10 cijfers staan.',
        koi_date: 'Je moet de datum (dd-mm-jjjj) invullen',
        koi_endDate: 'Einddatum moet groter zijn dan of gelijk aan startdatum',
        koi_enum: 'Kies één van de opties',
        koi_missingStartDate: 'StartDate ontbreekt',
        koi_time: 'Je moet de tijd invullen',
        koi_timeWithoutSeconds: 'Je moet de tijd invullen',
        min: '"{0} moet groter of gelijk zijn aan "{1}"',
        NO_MATCH_DATE: 'Geboortedatum komt niet overeen met BSN',
        NO_MATCH_DATE_BSN: 'Combinatie BSN en geboortedatum bestaat niet',
        NO_VALID_INSURANCE: 'Geen geldige verzekering',
        noMatchDateBsn:
            'We kunnen geen patiënt vinden met deze combinatie van geboortedatum en BSN. Controleer je invoer.',
        noMatchDateBsnTextCreate:
            'De combinatie BSN en geboortedatum komt niet overeen. Weet je zeker dat je deze patiënt wilt aanmaken?',
        noMatchDateBsnTextUpdate:
            'De combinatie BSN en geboortedatum komt niet overeen. Weet je zeker dat je de patiëntgegevens wilt overschrijven?',
        nonExistingBSN: 'BSN bestaat niet',
        noServiceGraderPoolProviders: 'Geen beoordelaars toegevoegd',
        number_base: 'Moet een nummer zijn',
        number_max: 'Getal moet kleiner zijn',
        number_min: 'Getal moet groter zijn',
        numberAsString_decimalComma: 'Scheidingsteken moet een komma zijn',
        numberAsString_decimalPoint: 'Scheidingsteken moet een punt zijn',
        numberAsString_greater: 'Getal moet groter zijn',
        numberAsString_leadingZero: 'Voorloopnullen niet toegestaan',
        numberAsString_less: 'Getal moet kleiner zijn',
        numberAsString_max: 'Getal moet kleiner zijn',
        numberAsString_maxDecimals: 'Teveel decimalen',
        numberAsString_min: 'Getal moet groter zijn',
        numberAsString_minDecimals: 'Te weinig decimalen',
        numberAsString_negativeZero: 'Moet een nummer zijn',
        numberAsString_noDecimals: 'Mag geen decimalen bevatten',
        numberAsString_notANumber: 'Moet een nummer zijn',
        object_min: 'Dit is een vereiste vraag',
        onePhoneNumberRequired: 'Vul ten minste 1 telefoonnummer in',
        OTP_SECRET_DOES_NOT_MATCH_TOTP_TOKEN: 'Onjuiste Google Authenticator code',
        passwordNotGoodEnough: 'Moet een score van 80% of meer hebben',
        permission_required: 'Om door te gaan moet er toestemming worden gegeven',
        REGISTRATION_CODE_EXPIRED: 'Je registratiecode is verlopen',
        REQUIRED: 'Verplicht',
        requiredForGp: 'Verplicht',
        requiredForRole: 'Verplicht',
        selectAtLeastOneSubCategory:
            'Je moet minstens één subcategorie selecteren als je een hoofdcategorie selecteert.',
        string_base: 'Mag niet leeg zijn',
        string_elfproef: 'Ongeldig BSN',
        string_email: 'Ongeldig e-mailadres',
        string_empty: 'Mag niet leeg zijn',
        string_ledgerNumber: 'Moet bestaan uit vier cijfers',
        string_max: 'De ingevoerde tekst bevat te veel karakters',
        string_min: 'De ingevoerde tekst bevat te weinig karakters',
        string_newPasswordRepeat: 'Moet gelijk zijn aan je gekozen wachtwoord',
        string_numeric: 'Moet bestaan uit cijfers',
        string_pattern: {
            base: 'Mag niet leeg zijn',
        },
        string_regex: 'De ingevoerde waarde matcht niet met het verplichte patroon',
        string_registrationCode: 'Moet bestaan uit twaalf letters',
        string_totpToken: 'Moet bestaan uit zes cijfers',
        timeParadox: 'moet na "{0}" zijn',
        USERNAME_EXISTS: 'Deze gebruikersnaam is reeds in gebruik',
        USERNAME_NOT_FOUND: 'Onbekende gebruikersnaam',
        weeks_required: 'Geef aantal weken op',
        WRONG_PASSWORD: 'Onjuist wachtwoord',
        WRONG_REGISTRATION_CODE: 'Onjuiste registratiecode',
        WRONG_TOTP_TOKEN: 'Onjuiste Google Authenticator code',
    },
};
